import React, { useEffect, useState } from "react";
import { EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import { DotButton, useDotButton } from "./EmblaCarouselDotButton";
import styles from "./Carousel.module.css";
import { AspectRatio, Box, Chip, Typography } from "@mui/joy";
import { theme } from "../Theme";
import { isUrl } from "../../utils/misc";
import VideoPlayer from "../VideoPlayer";

type Props = {
  slides: string[];
  businessId: string;
  options?: EmblaOptionsType;
  onClick?: (image: string) => void;
};

const EmblaCarousel: React.FC<Props> = ({
  slides,
  businessId,
  options,
  onClick,
}: Props) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (emblaApi) {
      emblaApi.on("select", () => {
        console.log(`Current index is ${emblaApi.selectedScrollSnap()}`);
        setCurrentIndex(emblaApi.selectedScrollSnap());
      });
    }
  }, [emblaApi]);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const getVideoIndex = () => {
    return slides.findIndex((slide) => slide.endsWith("-video"));
  };
  console.log("WHAT IS VIDEO INDEX", getVideoIndex());

  console.log("SCROLL SNAPS", scrollSnaps);
  console.log("IMAGES", slides);

  return (
    <Box position="relative">
      <section className={styles.embla}>
        <div className={styles.embla__viewport} ref={emblaRef}>
          <div
            className={styles.embla__container}
            // style={{
            //   position: "relative",
            // }}
          >
            {slides.map((slide, index: any) => {
              const imageUrl = isUrl(slide)
                ? slide
                : `${
                    import.meta.env.VITE_API_URL
                  }/objects/${businessId}/${slide}`;
              const isVideo = slides[index].endsWith("-video");

              return (
                <div className={styles.embla__slide} key={index}>
                  <div className={styles.embla__slide__number}>
                    <AspectRatio
                      ratio={1}
                      variant="plain"
                      sx={{
                        width: "360px",
                        height: "360px",
                        cursor: "pointer",
                        borderRadius: "8px",
                        objectFit: "cover",
                      }}
                      onClick={() => onClick?.(imageUrl)}
                    >
                      {isVideo ? (
                        <VideoPlayer
                          width={"360px"}
                          height={"360px"}
                          videoSrc={`${
                            import.meta.env.VITE_API_URL
                          }/objects/${businessId}/${slides[index]}`}
                          stopProp={true}
                          withMute
                          ratioFill="plain"
                        />
                      ) : (
                        <img
                          alt={`${slide}-${index}`}
                          src={imageUrl}
                          width={"100%"}
                          height={"100%"}
                          onError={(e) => {
                            (e.target as HTMLImageElement).src =
                              "/inventory-form-no-img.png";
                          }}
                          style={{
                            objectFit: "contain",
                            objectPosition: "center",
                          }}
                        />
                      )}

                      {slides.length &&
                      !slides[currentIndex].endsWith("-video") ? (
                        <Chip
                          sx={{
                            position: "absolute",
                            backgroundColor:
                              theme.palette.others.carousel_index_bg,
                            bottom: { xs: "4%", lg: "4%" },
                            right: { xs: "4%", lg: "4%" },
                            zIndex: 100,
                            py: "4px",
                            px: "8px",
                            borderRadius: "4px",
                          }}
                        >
                          <Typography level="text-xs-regular">
                            {currentIndex + 1}/
                            {getVideoIndex() > 0
                              ? slides.length - 1
                              : slides.length}
                          </Typography>
                        </Chip>
                      ) : null}
                    </AspectRatio>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {slides.length > 1 && (
          <div className="embla__controls my-4">
            <div className="embla__dots flex gap-2">
              {scrollSnaps.map((_, index) => {
                const isVideo = slides[index].endsWith("-video");

                return (
                  <DotButton
                    key={index}
                    onClick={() => onDotButtonClick(index)}
                    className={"embla__dot".concat(
                      index === selectedIndex
                        ? " embla__dot--selected border border-gray-900 rounded p-1"
                        : "p-1"
                    )}
                  >
                    <AspectRatio
                      ratio={1}
                      variant="plain"
                      sx={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "8px",
                      }}
                    >
                      {isVideo ? (
                        <VideoPlayer
                          width={"64px"}
                          height={"64px"}
                          videoSrc={`${
                            import.meta.env.VITE_API_URL
                          }/objects/${businessId}/${slides[index]}`}
                          disabled
                          playButtonConfig={{
                            width: "40.48px",
                            height: "40.48px",
                            icon: {
                              width: "16.24px",
                              height: "16.24px",
                            },
                          }}
                          ratioFill="plain"
                        />
                      ) : (
                        <img
                          alt={`product-items`}
                          src={`${
                            import.meta.env.VITE_API_URL
                          }/objects/${businessId}/${slides[index]}`}
                          onError={(e) => {
                            (e.target as HTMLImageElement).src =
                              "/inventory-form-no-img.png";
                          }}
                        />
                      )}
                    </AspectRatio>
                  </DotButton>
                );
              })}
            </div>
          </div>
        )}
      </section>
    </Box>
  );
};

export default EmblaCarousel;
